module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-icon",
    class: {
      corner: _vm.corner
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "nudge-top": 18
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "border-radius": "99px",
            "background-color": "rgba(255,255,255,0.3)"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
            }
          }
        }, on), [_c('v-btn', {
          attrs: {
            "small": _vm.small,
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": _vm.small
          }
        }, [_vm._v("close")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "pa-4 center-text"
  }, [_c('div', [_vm._v("\n                Are you sure?\n            ")]), _vm._v(" "), _c('div', [_c('v-icon', {
    staticClass: "alert-icon grey--text text--lighten-2",
    class: {
      small: _vm.small
    }
  }, [_vm._v("mdi-alert-circle")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "error",
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2264468a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ConfirmIcon.vue
// module id = 2480
// module chunks = 1